var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85446 1.35629L15.8545 8.39241C15.9477 8.4861 16 8.61289 16 8.74505V16.5C16 16.7761 15.7761 17 15.5 17H11.25C10.9739 17 10.75 16.7761 10.75 16.5V12.3483C10.75 12.0722 10.5261 11.8483 10.25 11.8483H6.75C6.47386 11.8483 6.25 12.0722 6.25 12.3483V16.5C6.25 16.7761 6.02614 17 5.75 17H1.5C1.22386 17 1 16.7761 1 16.5V8.74505C1 8.61289 1.05233 8.4861 1.14554 8.39241L8.14554 1.35629C8.34101 1.15981 8.65899 1.15981 8.85446 1.35629Z",
    stroke: "#003393",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.bde3702e7ea1242b017bb0c584d80a39.svg";
export { ForwardRef as ReactComponent };